module.exports = __webpack_public_path__ + "static/img/cert12.be69c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert12.png
// module id = bxCo
// module chunks = 52